import React, { useMemo } from "react";
import Header from "./Header";
import DiagonalUpArrow from "./Icons/DiagonalUpArrow";
import DownArrow from "./Icons/DownArrow";

import Break from "./Break";
import "./Home.scss";

// old stuff
import Link from "../routes/Home/components/Link";
import * as ROUTES from "../routes/Home/constants/routes";
import ContactAndFooter from "./ContactAndFooter";

export default function Home() {
  const Bear = require("../assets/Bear.svg");
  const HUBS = useMemo(
    () => [
      {
        code: "LA",
        label: "Los Angeles",
        phone: "+1 310 482 4200",
        // cant `import` for some reason
        icon: require("../assets/LA.svg"),
      },
      {
        code: "LDN",
        label: "London",
        phone: "+44 20 3023 8500",
        icon: require("../assets/LDN.svg"),
      },
      {
        code: "MIA",
        label: "Miami",
        phone: "+1 310 482 4200",
        icon: require("../assets/MIA.svg"),
      },
      {
        code: "SHG",
        label: "Shanghai",
        phone: "+86 21 2223 0600",
        icon: require("../assets/SHG.svg"),
      },
      {
        code: "SYD",
        label: "Sydney",
        phone: "+61 2 8584 5500",
        icon: require("../assets/SYD.svg"),
      },
      {
        code: "SGP",
        label: "Singapore",
        phone: "+65 6225 5288",
        icon: require("../assets/SGP.svg"),
      },
      {
        code: "TYO",
        label: "Tokyo",
        phone: "+81 3 5446 7400",
        icon: require("../assets/TYO.svg"),
      },
      {
        code: "SEO",
        label: "Seoul",
        phone: "+82 2 501 8888",
        icon: require("../assets/SEO.svg"),
      },
    ],
    [],
  );

  return (
    <div className="home">
      <Header />
      <div className="wrapper">
        {/*  */}
        <div className="ha">
          <h1>
            We are the bespoke
            <br />
            global agency for
            <br />
            Apple and only{" "}
            <Link
              className="apple-link"
              to="https://www.apple.com/"
              target="_blank"
              rel="noreferrer"
            >
              Apple
              <div className="apple-arrow">
                <DiagonalUpArrow />
              </div>
            </Link>
          </h1>
        </div>

        <Break />

        <section className="oa">
          <h1 style={{ paddingBottom: "15.873015873015872vw" }}>
            One agency
            <br />
            Eight Hubs
          </h1>
          <div className="hubs">
            {HUBS.map((hub, index) => {
              return (
                <div
                  className={["hub", index < 4 && "bottom"]
                    .filter(Boolean)
                    .join(" ")}
                  key={hub.code}
                >
                  <img src={hub.icon} />
                  <div>
                    {hub.label}
                    <br />
                    {hub.phone}
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        <Break />

        <section className="wwu">
          <h1 style={{ marginBottom: "1.3227513227513228vw" }}>
            Interested in
            <br />
            Working with us?
          </h1>
          <div className="down-arrow">
            <DownArrow />
          </div>

          <Link to={ROUTES.HOME_CAREERS} className="open-roles">
            View open roles
          </Link>
        </section>

        <Break />

        <section className="what-we-do">
          <div className="wwd">What we do</div>
          <div>
            <div>ADVERTISING</div>
            <div>MARKETING</div>
            <div>STRATEGY</div>
            <div>CREATIVE</div>
          </div>
          <div>
            <div>GRAPHIC DESIGN</div>
            <div>WEBSITE DESIGN</div>
            <div>PHOTOGRAPHIC SERVICE</div>
            <div>VIDEO PRODUCTION</div>
          </div>
          <img src={Bear} className="wwd-bear" style={{ width: "10.25vw" }} />
        </section>

        <ContactAndFooter />
      </div>
    </div>
  );
}
